export const PatreonStatus = Object.freeze({
    Unlinked: 0,
    Linked: 1,
    Pledged: 2
});
